type ParsedTabRoute = { section: string; id?: string };

export const parseTabRoute = (path: string): ParsedTabRoute => {
  const segments = path.split('/').filter(Boolean);
  return { section: segments[0] ?? '', id: segments[1] };
};
